import { MapTo } from '@adobe/aem-react-editable-components';
import { AEM_FUNCTIONS } from '@yme/common/aem-functions';
import { ProductVideo } from './ProductVideo';
import { isProductVideoEmpty } from './helpers';
const productVideoEditConfig = {
    emptyLabel: 'Product Video',
    isEmpty: isProductVideoEmpty,
};
export default MapTo(AEM_FUNCTIONS.productVideo)(ProductVideo, productVideoEditConfig);
